import { ProductImage } from "scrivito/Objs/Product/Components/ProductImage"

import { useProductInformation } from "entities/products/model/useProductInformation"
import { useProductObj } from "entities/products/model/useProductObj"

import { ExternalDimensioningBaseProductCardProps } from "../ExternalDimensioningBaseProductCard"

interface UseExternalDimensioningBaseProductCardModelArgs {
  variantKey: string
}

export function useExternalDimensioningBaseProductCardModel({
  variantKey
}: UseExternalDimensioningBaseProductCardModelArgs): ExternalDimensioningBaseProductCardProps {
  const { productObj, productBaseVariantObj } = useProductObj(variantKey)
  const { productInformation, isLoading } = useProductInformation({
    variantKey
  })

  const titleShort =
    (productBaseVariantObj?.get("titleShort") as string) ||
    (productObj?.get("titleShort") as string)

  return {
    image: <ProductImage obj={productBaseVariantObj ?? productObj} />,
    title: titleShort || variantKey,
    subtitle: productInformation?.productKind,
    isLoading
  }
}
